var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.92 101.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3689",
    "data-name": "Raggruppa 3689",
    transform: "translate(-0.001 0.001)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3588",
    "data-name": "Tracciato 3588",
    d: "M7664.948,9179.9h0a4.5,4.5,0,0,0,.035,6.315l31.521,31.946a4.462,4.462,0,0,0,6.314-.037h0a4.5,4.5,0,0,0-.037-6.312l-31.521-31.948A4.458,4.458,0,0,0,7664.948,9179.9Z",
    transform: "translate(-7660.292 -9145.969)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3589",
    "data-name": "Tracciato 3589",
    d: "M7735.941,9253.936l-24.221,4.731L7708,9239.639l-17.032-24.592,36-7.031Z",
    transform: "translate(-7675.575 -9162.451)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3590",
    "data-name": "Tracciato 3590",
    d: "M7665.918,9212.51h0a4.5,4.5,0,0,0,.036,6.313l31.522,31.947a4.459,4.459,0,0,0,6.314-.037h0a4.5,4.5,0,0,0-.037-6.313l-31.521-31.946A4.457,4.457,0,0,0,7665.918,9212.51Z",
    transform: "translate(-7660.834 -9164.223)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3591",
    "data-name": "Tracciato 3591",
    d: "M7658.216,9139.936h0a4.5,4.5,0,0,0,.036,6.313l30.371,30.743a4.456,4.456,0,0,0,6.313-.036h0a4.493,4.493,0,0,0-.037-6.312L7664.53,9139.9A4.457,4.457,0,0,0,7658.216,9139.936Z",
    transform: "translate(-7656.523 -9123.595)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2239",
    "data-name": "Raggruppa 2239",
    transform: "translate(10.057 -0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2008",
    "data-name": "Rettangolo 2008",
    width: 37.628,
    height: 68.005,
    rx: 5,
    fill: "#a5a093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_2009",
    "data-name": "Rettangolo 2009",
    d: "M.247,0H30.761a.248.248,0,0,1,.248.248V54.7a.247.247,0,0,1-.247.247H.247A.247.247,0,0,1,0,54.7V.247A.247.247,0,0,1,.247,0Z",
    transform: "translate(3.31 6.219)",
    fill: "#eae8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_2010",
    "data-name": "Rettangolo 2010",
    d: "M.563,0H11.971a.563.563,0,0,1,.563.563v0a.562.562,0,0,1-.562.562H.562A.562.562,0,0,1,0,.563v0A.563.563,0,0,1,.563,0Z",
    transform: "translate(12.547 1.835)",
    fill: "#dbd7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3592",
    "data-name": "Tracciato 3592",
    d: "M7719.164,9246.662a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,7719.164,9246.662Z",
    transform: "translate(-7700.35 -9184.084)",
    fill: "#dbd7d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3593",
    "data-name": "Tracciato 3593",
    d: "M7659.194,9205.849h0a4.483,4.483,0,0,0,.035,6.313l5.915,5.873a4.476,4.476,0,0,0,6.313-.036h0a4.48,4.48,0,0,0-.036-6.313l-5.913-5.874A4.473,4.473,0,0,0,7659.194,9205.849Z",
    transform: "translate(-7657.067 -9160.497)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3594",
    "data-name": "Tracciato 3594",
    d: "M7657.276,9172.3h0a4.481,4.481,0,0,0,.035,6.312l5.037,5a4.477,4.477,0,0,0,6.313-.035h0a4.479,4.479,0,0,0-.036-6.312l-5.037-5A4.469,4.469,0,0,0,7657.276,9172.3Z",
    transform: "translate(-7655.994 -9141.716)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3595",
    "data-name": "Tracciato 3595",
    d: "M7758.228,9294.367l-30.6,5.978,1.369,11.988a65.094,65.094,0,0,0,31.021-8.827Z",
    transform: "translate(-7696.093 -9210.791)",
    fill: "#9e998f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3596",
    "data-name": "Tracciato 3596",
    d: "M7769.2,9215.013l-3.095.6-.412-3.9-3.32-31.267c-.562-5.295,2.108-7.42,5.3-8.452,1.76-.568,2.18-1.056,2.351.558l3.8,35.789A6.141,6.141,0,0,1,7769.2,9215.013Z",
    transform: "translate(-7715.505 -9141.989)",
    fill: "#eae8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2240",
    "data-name": "Raggruppa 2240",
    transform: "translate(22.38 27.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3597",
    "data-name": "Tracciato 3597",
    d: "M7712.175,9168.538a.277.277,0,0,0-.3.041l-2.393,2.054-2.368,0h0a.278.278,0,0,0-.279.278v3.229a.278.278,0,0,0,.279.279h2.221l2.546,2.056a.281.281,0,0,0,.177.063.27.27,0,0,0,.119-.028.277.277,0,0,0,.16-.253v-7.464A.275.275,0,0,0,7712.175,9168.538Z",
    transform: "translate(-7706.836 -9167.452)",
    fill: "#a5a093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3598",
    "data-name": "Tracciato 3598",
    d: "M7721.7,9172.123a.28.28,0,0,0-.046.393,3.3,3.3,0,0,1,0,3.992.278.278,0,0,0,.046.392.267.267,0,0,0,.173.062.277.277,0,0,0,.219-.107,3.867,3.867,0,0,0,0-4.685A.28.28,0,0,0,7721.7,9172.123Z",
    transform: "translate(-7715.098 -9169.439)",
    fill: "#a5a093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3599",
    "data-name": "Tracciato 3599",
    d: "M7726.39,9169.825a.282.282,0,0,0-.062.393,5.235,5.235,0,0,1,0,6.025.278.278,0,0,0,.062.39.287.287,0,0,0,.165.054.279.279,0,0,0,.226-.115,5.9,5.9,0,0,0,0-6.685A.282.282,0,0,0,7726.39,9169.825Z",
    transform: "translate(-7717.717 -9168.157)",
    fill: "#a5a093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3600",
    "data-name": "Tracciato 3600",
    d: "M7730.608,9166.156a.278.278,0,0,0-.066.389c.034.048,3.252,4.684,0,9.26a.282.282,0,0,0,.066.392.276.276,0,0,0,.162.05.28.28,0,0,0,.229-.116c3.479-4.9.035-9.858,0-9.908A.281.281,0,0,0,7730.608,9166.156Z",
    transform: "translate(-7720.078 -9166.104)",
    fill: "#a5a093"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.944f0ca64141b991fc57e02ddb4d5b8e.svg";
export { ForwardRef as ReactComponent };